<template>
  <div class="app-container">
    <div
      style="background-color: rgb(255, 255, 255); position: relative; height: calc(100% + 0px); width: 100%; padding: 20px;">


      <div class=" osteps">


        <el-steps :active="stepactive">

          <el-step>
             <template slot="title">
      步骤1<div style="width: 100%; height: 2px; background-color: #dcdfe6; margin-top: 10px;"></div>
    </template>
          </el-step>
          <el-step title="上传招标文件" description="AI解析，提取参数">
          </el-step>
          <el-step title="填写基本信息" description="输入详细的基本信息">
          </el-step>
          <el-step title="生成标书大纲" description="AI生成大纲"></el-step>
          <el-step title="生成投标文件" description="AI一键全文生成"></el-step>
        </el-steps>
      </div>

      <div v-show="stepactive == 1">
        <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em><br>
            <!-- <span class="el-upload__text" >必须为清晰、完整的彩色原件扫描件、数码照，或者电子营业执照</span> -->
            必须为清晰、完整的彩色原件扫描件、数码照，或者电子营业执照
            <!-- <br><span class="el-upload__text" style="color: rgba(0,0,0,1);font-size: 16px;font-family: AlibabaPuHui;font-weight: 400;line-height: 23px;">仅支持 png、jpg、bmp的图片格式，图片大小上限4M</span>   -->
            <br>仅支持 png、jpg、bmp的图片格式，图片大小上限4M
          </div>
          <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>


        <el-row :gutter="20" class="elrow">
          <el-col :span="8">

            <!-- <el-card class="box-card" body-style="height: calc(100% - 50px)" style="overflow-y: auto;"> -->
            <el-card ref="myCard1" class="box-card" :body-style="{ height: cardh + 'px', overflowY: 'auto' }">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;</div>
                  <span style="padding-left: 6px;  position: absolute;font-weight: 650;">招标要求</span>
                  <span
                    style="padding-left: 120px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span>
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard1')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- <div v-for="o in 4" :key="o" class="text item">
    {{'列表内容 ' + o }}
  </div> -->

              <div>
                <span style=" font-weight: 650; width: 65px;">项目背景</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                <span style=" font-weight: 650; width: 65px;font-size: 16px">招标内容</span>
                <br />

                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">1.核心引擎：</span>提供基于视觉大模型（ViT、SAM等相关技术）构建的新一代OCR识别引擎。<br />
                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">2.系统功能：</span>具备强大的文档分析与识别能力，包括复杂版面分析、表格识别、手写体识别、多语言混合识别、印章遮挡处理等。
                <br /><span
                  style="font-weight: 650; width: 65px;font-size: 14px">3.API接口：</span>提供稳定、高效、安全的API接口，支持与我单位现有业务系统进行集成。
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）

              </div>

            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card ref="myCard2" class="box-card" :body-style="{ height: cardh + 'px', overflowY: 'auto' }">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;</div>
                  <span style="padding-left: 6px; position: absolute;font-weight: 650;">评分标准</span>
                  <span
                    style="padding-left: 120px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span>
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard2')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- <div v-for="o in 4" :key="o" class="text item">
    {{'列表内容 ' + o }}
  </div> -->

              <div>
                <span style=" font-weight: 650; width: 65px;">项目背景</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                <span style=" font-weight: 650; width: 65px;font-size: 16px">招标内容</span>
                <br />

                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">1.核心引擎：</span>提供基于视觉大模型（ViT、SAM等相关技术）构建的新一代OCR识别引擎。<br />
                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">2.系统功能：</span>具备强大的文档分析与识别能力，包括复杂版面分析、表格识别、手写体识别、多语言混合识别、印章遮挡处理等。
                <br /><span
                  style="font-weight: 650; width: 65px;font-size: 14px">3.API接口：</span>提供稳定、高效、安全的API接口，支持与我单位现有业务系统进行集成。
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）

              </div>

            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card ref="myCard3" class="box-card" :body-style="{ height: cardh + 'px', overflowY: 'auto' }">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;</div>
                  <span style="padding-left: 6px; position: absolute;font-weight: 650;">标书目录</span>
                  <span
                    style="padding-left: 120px; position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span>
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard3')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- <div v-for="o in 4" :key="o" class="text item">
    {{'列表内容 ' + o }}
  </div> -->

              <div>
                <span style=" font-weight: 650; width: 65px;">项目背景</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                <span style=" font-weight: 650; width: 65px;font-size: 16px">招标内容</span>
                <br />

                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">1.核心引擎：</span>提供基于视觉大模型（ViT、SAM等相关技术）构建的新一代OCR识别引擎。<br />
                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">2.系统功能：</span>具备强大的文档分析与识别能力，包括复杂版面分析、表格识别、手写体识别、多语言混合识别、印章遮挡处理等。
                <br /><span
                  style="font-weight: 650; width: 65px;font-size: 14px">3.API接口：</span>提供稳定、高效、安全的API接口，支持与我单位现有业务系统进行集成。
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）

              </div>

            </el-card>

          </el-col>
        </el-row>
      </div>

      <div v-show="stepactive == 2">

        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px" class="osteps"
          style="margin-top: 22px;" label-position="left">

          <el-form-item label="选择项目类型" prop="bidNumber">

            <el-radio v-model="queryParams.radio1" label="1" border class="no-input">
              <svg height="24" node-id="1" sillyvg="true" template-height="1024" template-width="1024" version="1.1"
                viewBox="0 0 1024 1024" width="24" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs node-id="56">
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_38" node-id="5" spreadMethod="pad"
                    x1="24.09" x2="482.95" y1="527.16" y2="784.5">
                    <stop offset="0" stop-color="#3b8aff" />
                    <stop offset="1" stop-color="#5e9dff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_117" node-id="8" spreadMethod="pad"
                    x1="630.75" x2="417.54" y1="70.22" y2="546.71">
                    <stop offset="0" stop-color="#99c1ff" />
                    <stop offset="0.46" stop-color="#ecf3ff" />
                    <stop offset="0.58" stop-color="#ecf3ff" />
                    <stop offset="0.89" stop-color="#b4d3ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_53" node-id="13" spreadMethod="pad"
                    x1="1018.65" x2="536.07" y1="623.32" y2="613.15">
                    <stop offset="0" stop-color="#0069ff" />
                    <stop offset="0.72" stop-color="#0075ff" />
                    <stop offset="1" stop-color="#5e9dff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130" node-id="17" spreadMethod="pad"
                    x1="171.16" x2="178.52" y1="450.79" y2="423.27">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-2" node-id="20" spreadMethod="pad"
                    x1="602.39" x2="586.7" y1="157.24" y2="193.28">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-3" node-id="21" spreadMethod="pad"
                    x1="660.67" x2="649.82" y1="170.84" y2="201.07">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-4" node-id="22" spreadMethod="pad"
                    x1="716.04" x2="702.09" y1="188.84" y2="226.05">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-5" node-id="23" spreadMethod="pad"
                    x1="776.62" x2="768.86" y1="205.7" y2="242.13">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-6" node-id="24" spreadMethod="pad"
                    x1="225.36" x2="227.69" y1="478.53" y2="449.07">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-7" node-id="25" spreadMethod="pad"
                    x1="274.11" x2="277.98" y1="513.42" y2="476.6">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_130-8" node-id="26" spreadMethod="pad"
                    x1="326.31" x2="329.8" y1="543.19" y2="509.86">
                    <stop offset="0" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#509eff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_75" node-id="27" spreadMethod="pad"
                    x1="650.6" x2="588.98" y1="722.78" y2="685.19">
                    <stop offset="0" stop-color="#a1c6ff" />
                    <stop offset="0.44" stop-color="#0049e5" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_75-2" node-id="30" spreadMethod="pad"
                    x1="745.41" x2="683.79" y1="668.24" y2="630.65">
                    <stop offset="0" stop-color="#a1c6ff" />
                    <stop offset="0.44" stop-color="#0049e5" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_75-3" node-id="31" spreadMethod="pad"
                    x1="835.21" x2="773.59" y1="616.6" y2="579">
                    <stop offset="0" stop-color="#a1c6ff" />
                    <stop offset="0.44" stop-color="#0049e5" />
                  </linearGradient>
                </defs>
                <path
                  d="M 438.45 610.42 L 15.25 378.42 C 5.65 373.42 0.59 366.93 0.00 360.10 L 0.00 634.80 C 0.59 641.63 5.65 648.12 15.25 653.09 L 438.45 913.09 Z"
                  fill="url(#未命名的渐变_38)" fill-rule="nonzero" node-id="149" stroke="none" target-height="552.99"
                  target-width="438.45" target-x="0" target-y="360.1" />
                <path
                  d="M 384.28 112.06 C 407.51 98.83 444.95 95.48 470.43 104.37 L 1000.97 289.37 C 1029.71 299.37 1031.87 320.84 1005.65 335.77 L 531.00 606.00 C 504.77 621.00 461.41 623.00 437.12 610.42 L 15.31 378.55 C -6.21 367.41 -4.91 348.70 18.31 335.45 Z"
                  fill="url(#未命名的渐变_117)" fill-rule="nonzero" node-id="151" stroke="none" target-height="527.52"
                  target-width="1038.08" target-x="-6.21" target-y="95.48" />
                <path
                  d="M 1023.94 626.00 L 1023.94 310.93 C 1024.01 311.80 1024.01 312.67 1023.94 313.54 C 1023.94 313.82 1023.94 314.11 1023.87 314.40 C 1023.75 315.38 1023.55 316.35 1023.26 317.29 L 1023.19 317.47 C 1022.88 318.40 1022.51 319.30 1022.08 320.18 C 1021.93 320.48 1021.76 320.78 1021.59 321.08 C 1021.21 321.77 1020.80 322.44 1020.35 323.08 C 1020.12 323.43 1019.89 323.77 1019.63 324.08 C 1019.16 324.71 1018.63 325.33 1018.09 325.95 C 1017.75 326.34 1017.43 326.72 1017.09 327.10 C 1016.75 327.48 1016.09 328.10 1015.57 328.55 C 1015.05 329.00 1014.34 329.70 1013.65 330.26 C 1012.65 331.04 1011.65 331.81 1010.65 332.57 L 1010.21 332.89 C 1008.82 333.84 1007.34 334.78 1005.74 335.69 L 531.00 606.00 C 529.00 607.16 483.60 630.72 438.45 610.39 L 438.45 913.09 C 475.85 934.78 531.00 920.09 536.66 915.04 L 1005.66 650.79 L 1005.66 650.79 L 1006.53 650.29 C 1007.80 649.54 1009.00 648.77 1010.13 647.99 L 1010.58 647.66 C 1011.47 647.03 1012.35 646.40 1013.15 645.75 C 1013.31 645.63 1013.43 645.49 1013.59 645.36 C 1014.28 644.80 1014.89 644.22 1015.51 643.64 C 1015.90 643.28 1016.35 642.93 1016.71 642.57 C 1016.83 642.45 1016.91 642.32 1017.03 642.21 C 1017.40 641.82 1017.72 641.43 1018.03 641.05 C 1018.34 640.67 1018.82 640.20 1019.15 639.78 C 1019.31 639.58 1019.42 639.38 1019.57 639.18 C 1019.72 638.98 1020.06 638.50 1020.29 638.18 C 1020.52 637.86 1020.77 637.55 1020.96 637.23 C 1021.15 636.91 1021.34 636.52 1021.53 636.16 C 1021.72 635.80 1021.87 635.56 1022.02 635.25 C 1022.17 634.94 1022.21 634.92 1022.29 634.75 C 1022.61 634.04 1022.89 633.30 1023.13 632.56 C 1023.13 632.50 1023.18 632.43 1023.20 632.36 L 1023.20 632.36 C 1023.44 631.57 1023.62 630.76 1023.76 629.94 C 1023.76 629.79 1023.76 629.65 1023.76 629.51 C 1023.76 629.37 1023.76 628.93 1023.83 628.64 C 1023.90 628.35 1023.93 627.87 1023.93 627.48 C 1023.93 627.09 1024.00 626.49 1023.94 626.00 Z"
                  fill="url(#未命名的渐变_53)" fill-rule="nonzero" node-id="153" stroke="none" target-height="623.85004"
                  target-width="585.5649" target-x="438.45" target-y="310.93" />
                <path
                  d="M 1005.63 335.77 L 531.00 606.00 C 504.78 621.00 461.43 622.92 437.16 610.40 L 15.28 378.56 C 2.42 371.85 436.13 596.26 436.13 596.26 C 460.39 608.85 503.75 606.82 529.97 591.85 C 530.00 591.85 1020.81 327.10 1005.63 335.77 Z"
                  fill="#ffffff" fill-rule="nonzero" node-id="155" stroke="none" target-height="295.81998"
                  target-width="1018.3901" target-x="2.42" target-y="327.1" />
                <path d="M 157.97 520.58 L 145.22 513.59 L 145.22 449.98 L 157.97 456.97 L 157.97 520.58 Z"
                  fill="#005bff" fill-rule="nonzero" node-id="157" stroke="none" target-height="70.600006"
                  target-width="12.75" target-x="145.22" target-y="449.98" />
                <path d="M 157.97 457.04 L 145.22 450.04 L 190.27 422.43 L 203.02 429.42 L 157.97 457.04 Z"
                  fill="url(#未命名的渐变_130)" fill-rule="nonzero" node-id="159" stroke="none" target-height="34.610016"
                  target-width="57.800003" target-x="145.22" target-y="422.43" />
                <path d="M 581.97 186.58 L 566.57 181.23 L 611.62 153.61 L 627.02 158.97 L 581.97 186.58 Z"
                  fill="url(#未命名的渐变_130-2)" fill-rule="nonzero" node-id="161" stroke="none" target-height="32.97"
                  target-width="60.450012" target-x="566.57" target-y="153.61" />
                <path d="M 638.94 206.58 L 623.53 201.22 L 668.59 173.60 L 683.99 178.96 L 638.94 206.58 Z"
                  fill="url(#未命名的渐变_130-3)" fill-rule="nonzero" node-id="163" stroke="none" target-height="32.979996"
                  target-width="60.45996" target-x="623.53" target-y="173.6" />
                <path d="M 693.58 225.68 L 678.18 220.32 L 723.23 192.71 L 738.63 198.06 L 693.58 225.68 Z"
                  fill="url(#未命名的渐变_130-4)" fill-rule="nonzero" node-id="165" stroke="none" target-height="32.969986"
                  target-width="60.450073" target-x="678.18" target-y="192.71" />
                <path d="M 756.37 247.69 L 740.96 242.33 L 786.01 214.71 L 801.42 220.07 L 756.37 247.69 Z"
                  fill="url(#未命名的渐变_130-5)" fill-rule="nonzero" node-id="167" stroke="none" target-height="32.97998"
                  target-width="60.45996" target-x="740.96" target-y="214.71" />
                <path d="M 210.01 549.20 L 197.26 542.21 L 197.26 478.60 L 210.01 485.59 L 210.01 549.20 Z"
                  fill="#005bff" fill-rule="nonzero" node-id="169" stroke="none" target-height="70.60004"
                  target-width="12.75" target-x="197.26" target-y="478.59998" />
                <path d="M 210.01 485.66 L 197.26 478.67 L 242.32 451.05 L 255.06 458.04 L 210.01 485.66 Z"
                  fill="url(#未命名的渐变_130-6)" fill-rule="nonzero" node-id="171" stroke="none" target-height="34.609985"
                  target-width="57.799988" target-x="197.26" target-y="451.05002" />
                <path d="M 259.81 576.61 L 247.06 569.62 L 247.06 506.01 L 259.81 513.00 L 259.81 576.61 Z"
                  fill="#005bff" fill-rule="nonzero" node-id="173" stroke="none" target-height="70.599976"
                  target-width="12.750015" target-x="247.05998" target-y="506.01" />
                <path d="M 259.81 513.07 L 247.06 506.08 L 292.12 478.46 L 304.87 485.45 L 259.81 513.07 Z"
                  fill="url(#未命名的渐变_130-7)" fill-rule="nonzero" node-id="175" stroke="none" target-height="34.610016"
                  target-width="57.810013" target-x="247.05998" target-y="478.46" />
                <path d="M 312.10 605.46 L 299.35 598.47 L 299.35 534.86 L 312.10 541.85 L 312.10 605.46 Z"
                  fill="#005bff" fill-rule="nonzero" node-id="177" stroke="none" target-height="70.60004"
                  target-width="12.75" target-x="299.35" target-y="534.86" />
                <path d="M 312.10 541.92 L 299.35 534.92 L 344.41 507.31 L 357.15 514.30 L 312.10 541.92 Z"
                  fill="url(#未命名的渐变_130-8)" fill-rule="nonzero" node-id="179" stroke="none" target-height="34.609985"
                  target-width="57.799988" target-x="299.35" target-y="507.31" />
                <g node-id="215">
                  <path
                    d="M 958.05 506.74 C 964.71 518.27 956.25 535.63 939.15 545.50 C 922.05 555.37 902.79 554.02 896.13 542.49 C 889.47 530.95 897.93 513.59 915.03 503.72 C 932.13 493.85 951.39 495.20 958.05 506.74 Z"
                    fill="#6aa4ff" fill-rule="nonzero" group-id="1" node-id="183" stroke="none" target-height="61.52127"
                    target-width="75.24182" target-x="889.46765" target-y="493.84995" />
                </g>
                <g node-id="216">
                  <path
                    d="M 653.52 687.79 C 660.18 699.33 651.72 716.68 634.62 726.56 C 617.52 736.43 598.26 735.08 591.60 723.54 C 584.94 712.01 593.40 694.65 610.50 684.78 C 627.60 674.91 646.86 676.26 653.52 687.79 Z"
                    fill="url(#未命名的渐变_75)" fill-rule="nonzero" group-id="2" node-id="188" stroke="none"
                    target-height="61.5213" target-width="75.24194" target-x="584.93677" target-y="674.9075" />
                </g>
                <g node-id="217">
                  <path
                    d="M 648.32 688.84 C 654.51 699.57 646.64 715.71 630.74 724.89 C 614.85 734.07 596.94 732.81 590.74 722.08 C 584.55 711.35 592.42 695.22 608.31 686.04 C 624.21 676.86 642.12 678.11 648.32 688.84 Z"
                    fill="#0048e4" fill-rule="nonzero" group-id="3" node-id="193" stroke="none"
                    target-height="57.207764" target-width="69.96106" target-x="584.5482" target-y="676.8574" />
                </g>
                <g node-id="218">
                  <path
                    d="M 748.32 633.26 C 754.98 644.80 746.52 662.15 729.42 672.02 C 712.32 681.90 693.06 680.55 686.40 669.01 C 679.74 657.47 688.20 640.12 705.30 630.25 C 722.40 620.37 741.66 621.72 748.32 633.26 Z"
                    fill="url(#未命名的渐变_75-2)" fill-rule="nonzero" group-id="4" node-id="198" stroke="none"
                    target-height="61.52124" target-width="75.24182" target-x="679.736" target-y="620.3745" />
                </g>
                <g node-id="219">
                  <path
                    d="M 743.12 634.30 C 749.32 645.03 741.45 661.17 725.55 670.35 C 709.65 679.53 691.74 678.27 685.55 667.54 C 679.36 656.82 687.22 640.68 703.12 631.50 C 719.02 622.32 736.93 623.58 743.12 634.30 Z"
                    fill="#0048e4" fill-rule="nonzero" group-id="5" node-id="203" stroke="none"
                    target-height="57.207886" target-width="69.96112" target-x="679.356" target-y="622.3193" />
                </g>
                <g node-id="220">
                  <path
                    d="M 838.13 581.62 C 844.79 593.15 836.33 610.51 819.23 620.38 C 802.13 630.25 782.87 628.90 776.21 617.37 C 769.55 605.83 778.01 588.48 795.11 578.61 C 812.20 568.73 831.47 570.08 838.13 581.62 Z"
                    fill="url(#未命名的渐变_75-3)" fill-rule="nonzero" group-id="6" node-id="208" stroke="none"
                    target-height="61.52124" target-width="75.24194" target-x="769.54504" target-y="568.7329" />
                </g>
                <path
                  d="M 836.26 585.04 C 842.45 595.82 834.53 612.00 818.56 621.18 C 802.59 630.36 784.62 629.06 778.42 618.28 C 772.23 607.51 780.16 591.33 796.13 582.15 C 812.10 572.97 830.07 574.27 836.26 585.04 Z"
                  fill="#0048e4" fill-rule="nonzero" group-id="7" node-id="213" stroke="none" target-height="57.386047"
                  target-width="70.22534" target-x="772.2291" target-y="572.9706" />
              </svg>
              <span class=" one">服务类</span>
              <div class="two">一句话描述项目类型</div>

            </el-radio>
            <el-radio v-model="queryParams.radio1" label="2" border class="no-input">
              <svg height="24" node-id="1" sillyvg="true" template-height="1020" template-width="1020" version="1.1"
                viewBox="0 0 1024 1024" width="24" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs node-id="39">
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_15" node-id="5" spreadMethod="pad"
                    x1="246.45" x2="717.85" y1="818.64" y2="566.2">
                    <stop offset="0" stop-color="#ecf3ff" />
                    <stop offset="1" stop-color="#c9e2ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_5" node-id="8" spreadMethod="pad"
                    x1="102.05" x2="432.52" y1="768.26" y2="936.63">
                    <stop offset="0" stop-color="#c8e1ff" />
                    <stop offset="1" stop-color="#c5dfff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_12" node-id="11" spreadMethod="pad"
                    x1="467.09" x2="962.88" y1="859.09" y2="848.84">
                    <stop offset="0.06" stop-color="#c5dfff" />
                    <stop offset="0.23" stop-color="#8bb4f1" />
                    <stop offset="1" stop-color="#a2c5f7" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_322" node-id="15" spreadMethod="pad"
                    x1="265.41" x2="369.54" y1="737.17" y2="297.07">
                    <stop offset="0" stop-color="#0067ff" />
                    <stop offset="0.73" stop-color="#7fafff" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_325" node-id="18" spreadMethod="pad"
                    x1="-12706.18" x2="-12655.27" y1="778.15" y2="334.99">
                    <stop offset="0" stop-color="#0067ff" />
                    <stop offset="0.87" stop-color="#7fafff" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_49" node-id="21" spreadMethod="pad"
                    x1="170.64" x2="921.16" y1="543.55" y2="645.55">
                    <stop offset="0" stop-color="#bcd7fb" />
                    <stop offset="1" stop-color="#468fff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_27" node-id="24" spreadMethod="pad"
                    x1="366.7" x2="724" y1="209.78" y2="209.78">
                    <stop offset="0" stop-color="#3386ff" />
                    <stop offset="0.51" stop-color="#0066ff" />
                    <stop offset="1" stop-color="#2c82ff" />
                  </linearGradient>
                </defs>
                <path
                  d="M 408.29 456.65 C 447.38 433.50 513.76 432.89 556.54 455.26 L 904.91 637.40 C 947.69 659.77 950.72 696.66 911.62 719.80 L 593.67 908.00 C 554.57 931.15 488.20 931.76 445.42 909.39 L 97.05 727.28 C 54.27 704.91 51.24 668.00 90.34 644.87 Z"
                  fill="url(#未命名的渐变_15)" fill-rule="nonzero" node-id="88" stroke="none" target-height="498.87006"
                  target-width="899.4799" target-x="51.24" target-y="432.89" />
                <path
                  d="M 98.82 728.86 C 91.08 724.95 84.00 719.86 77.82 713.77 C 74.45 710.41 71.57 706.59 69.26 702.43 C 68.22 700.54 67.34 698.57 66.63 696.53 C 65.26 692.68 64.61 688.61 64.69 684.53 L 62.44 781.17 C 62.06 797.17 73.57 813.46 96.59 825.50 L 444.97 1007.64 L 447.19 911.00 Z"
                  fill="url(#未命名的渐变_5)" fill-rule="nonzero" node-id="90" stroke="none" target-height="323.11"
                  target-width="385.13" target-x="62.06" target-y="684.53" />
                <path
                  d="M 940.51 686.49 C 940.39 687.49 940.24 688.49 940.02 689.55 C 939.85 690.34 939.62 691.12 939.39 691.91 C 939.11 692.91 938.79 693.85 938.39 694.81 C 938.09 695.59 937.75 696.37 937.39 697.14 C 936.93 698.14 936.39 699.14 935.86 700.06 C 935.44 700.80 934.99 701.54 934.51 702.27 C 933.78 703.37 932.97 704.46 932.11 705.54 C 931.61 706.18 931.11 706.82 930.58 707.45 C 928.90 709.39 927.09 711.22 925.17 712.92 C 923.57 714.33 921.83 715.70 919.99 717.04 C 919.43 717.44 918.81 717.82 918.23 718.22 C 916.67 719.29 915.11 720.36 913.38 721.38 L 595.44 909.61 C 592.87 911.13 590.16 912.55 587.37 913.88 C 586.44 914.32 585.45 914.70 584.50 915.12 C 582.58 915.96 580.67 916.80 578.67 917.56 C 577.49 918.00 576.27 918.39 575.07 918.81 C 573.21 919.45 571.35 920.08 569.43 920.65 C 568.12 921.04 566.77 921.39 565.43 921.75 C 563.56 922.24 561.67 922.75 559.76 923.16 C 558.68 923.40 557.58 923.62 556.49 923.84 C 551.77 924.84 546.96 925.61 542.07 926.17 C 541.35 926.25 540.63 926.29 539.91 926.36 C 536.84 926.68 533.76 926.93 530.65 927.09 C 529.21 927.16 527.76 927.20 526.32 927.24 C 524.32 927.30 522.27 927.34 520.25 927.33 C 518.66 927.33 517.06 927.33 515.47 927.25 C 513.71 927.25 511.95 927.13 510.19 927.03 C 508.43 926.93 506.87 926.81 505.19 926.68 C 503.51 926.55 501.93 926.39 500.30 926.21 C 498.67 926.03 496.95 925.81 495.30 925.58 C 493.65 925.35 492.07 925.12 490.46 924.85 C 488.85 924.58 487.26 924.29 485.68 923.98 C 483.95 923.64 482.23 923.28 480.53 922.89 C 479.06 922.56 477.59 922.20 476.14 921.83 C 474.14 921.31 472.18 920.76 470.26 920.18 C 468.99 919.80 467.73 919.42 466.48 919.01 C 462.79 917.79 459.16 916.48 455.67 915.01 L 455.51 914.95 C 452.66 913.72 449.89 912.40 447.19 911.01 L 444.94 1007.65 C 447.61 1009.05 450.38 1010.36 453.26 1011.59 L 453.26 1011.59 L 453.40 1011.59 C 456.88 1013.07 460.51 1014.38 464.21 1015.59 C 464.65 1015.74 465.06 1015.93 465.51 1016.08 C 466.32 1016.33 467.17 1016.52 467.99 1016.77 C 469.93 1017.35 471.88 1017.90 473.87 1018.41 C 474.58 1018.60 475.25 1018.83 475.97 1019.00 C 476.69 1019.17 477.50 1019.31 478.26 1019.48 C 479.96 1019.87 481.67 1020.24 483.40 1020.57 C 484.24 1020.73 485.07 1020.94 485.91 1021.09 C 486.75 1021.24 487.43 1021.31 488.19 1021.44 C 489.80 1021.70 491.41 1021.94 493.03 1022.17 C 493.92 1022.29 494.80 1022.46 495.69 1022.57 C 496.58 1022.68 497.26 1022.71 498.05 1022.80 C 499.68 1022.98 501.30 1023.13 502.94 1023.26 C 503.82 1023.34 504.70 1023.46 505.58 1023.52 C 506.46 1023.58 507.14 1023.52 507.92 1023.62 C 509.68 1023.72 511.43 1023.79 513.20 1023.84 C 514.09 1023.84 514.99 1023.94 515.89 1023.95 C 516.58 1023.95 517.28 1023.95 517.98 1023.95 C 519.98 1023.95 521.98 1023.95 524.04 1023.86 C 525.04 1023.86 525.96 1023.86 526.91 1023.86 C 527.41 1023.86 527.91 1023.77 528.38 1023.74 C 531.48 1023.58 534.57 1023.34 537.63 1023.02 C 538.24 1022.96 538.87 1022.95 539.48 1022.88 L 539.79 1022.83 C 544.69 1022.27 549.49 1021.45 554.21 1020.50 C 554.73 1020.39 555.28 1020.35 555.79 1020.24 C 556.30 1020.13 556.91 1019.95 557.48 1019.82 C 559.40 1019.39 561.28 1018.90 563.16 1018.40 C 564.50 1018.05 565.84 1017.70 567.16 1017.31 C 569.08 1016.74 570.94 1016.11 572.80 1015.46 C 574.00 1015.05 575.22 1014.66 576.39 1014.22 C 578.39 1013.46 580.31 1012.62 582.23 1011.77 C 583.23 1011.35 584.17 1010.97 585.10 1010.53 C 587.89 1009.21 590.60 1007.79 593.17 1006.27 L 911.14 818.00 L 912.63 817.10 C 913.82 816.37 914.89 815.60 915.99 814.84 C 916.57 814.44 917.19 814.06 917.75 813.66 C 919.57 812.33 921.30 810.98 922.88 809.58 L 922.88 809.58 C 924.80 807.88 926.60 806.05 928.28 804.11 C 928.44 803.92 928.66 803.75 928.82 803.57 C 929.20 803.12 929.46 802.65 929.82 802.20 C 930.67 801.12 931.49 800.03 932.22 798.92 C 932.43 798.61 932.71 798.31 932.90 797.99 C 933.09 797.67 933.33 797.14 933.57 796.72 C 934.13 795.72 934.64 794.78 935.10 793.80 C 935.29 793.39 935.56 793.00 935.73 792.60 C 935.90 792.20 935.96 791.84 936.11 791.47 C 936.49 790.47 936.80 789.54 937.11 788.57 C 937.25 788.10 937.46 787.64 937.58 787.18 C 937.70 786.72 937.67 786.53 937.74 786.18 C 937.96 785.18 938.11 784.18 938.23 783.11 C 938.29 782.60 938.44 782.11 938.48 781.57 C 938.52 781.03 938.55 780.48 938.56 779.93 L 940.81 683.30 C 940.76 684.37 940.66 685.43 940.51 686.49 Z"
                  fill="url(#未命名的渐变_12)" fill-rule="nonzero" node-id="92" stroke="none" target-height="340.65002"
                  target-width="495.87" target-x="444.94" target-y="683.3" />
                <path
                  d="M 524.79 927.40 C 497.88 927.40 470.68 921.83 449.31 910.66 L 100.31 729.71 C 78.13 718.10 63.05 702.49 64.65 685.71 C 65.58 675.95 66.99 672.03 69.11 668.58 C 69.72 680.00 69.48 686.92 74.11 695.69 C 79.51 705.52 91.99 715.17 104.47 721.69 L 452.59 898.27 C 494.26 920.06 559.08 919.50 597.07 896.98 L 921.07 716.24 L 601.36 909.15 C 580.86 921.29 553.00 927.40 524.79 927.40 Z"
                  fill="#ffffff" fill-rule="nonzero" node-id="94" stroke="none" target-height="258.82"
                  target-width="858.02" target-x="63.05" target-y="668.58" />
                <path d="M 122.55 281.78 L 502.72 448.70 L 502.72 793.32 L 290.68 713.90 L 122.55 281.78 Z"
                  fill="url(#未命名的渐变_322)" fill-rule="nonzero" node-id="96" stroke="none" target-height="511.54"
                  target-width="380.17004" target-x="122.55" target-y="281.78" />
                <path d="M 861.85 281.78 L 502.72 448.70 L 502.72 793.32 L 714.76 713.90 L 861.85 281.78 Z"
                  fill="url(#未命名的渐变_325)" fill-rule="nonzero" node-id="98" stroke="none" target-height="511.54"
                  target-width="359.13" target-x="502.72003" target-y="281.78" />
                <path
                  d="M 199.00 550.89 L 465.27 680.89 C 486.27 691.16 518.78 691.16 539.75 680.89 L 806.00 550.89 C 832.00 538.28 832.00 513.05 806.00 500.37 L 539.77 370.37 C 518.77 360.14 486.26 360.14 465.30 370.37 L 199.00 500.40 C 173.06 513.09 173.06 538.24 199.00 550.93 Z M 224.80 521.29 L 476.83 398.61 C 490.68 391.82 514.56 391.82 528.42 398.61 L 780.22 521.29 C 789.22 525.70 789.22 528.36 780.22 532.77 L 528.42 652.69 C 514.56 659.44 490.65 659.44 476.79 652.69 L 224.79 532.69 C 215.75 528.36 215.75 525.70 224.77 521.29 Z M 806.00 626.35 L 756.33 602.08 L 744.30 629.00 L 785.52 645.70 C 794.83 650.25 794.83 652.95 785.52 657.50 L 529.06 778.00 C 514.81 785.00 490.19 785.00 475.90 778.00 L 222.35 657.51 C 213.08 652.96 213.08 650.26 222.35 645.71 L 259.80 629.00 L 247.51 602.68 L 199.00 626.35 C 173.00 639.00 173.00 664.19 199.00 676.91 L 465.24 807.00 C 486.24 817.27 518.75 817.27 539.72 807.00 L 806.00 676.87 C 831.94 664.19 831.94 639.03 806.00 626.35 Z"
                  fill="url(#未命名的渐变_49)" fill-rule="nonzero" node-id="100" stroke="none" target-height="457.13"
                  target-width="659" target-x="173" target-y="360.14" />
                <path d="M 261.61 203.50 L 724.00 0.00 L 606.79 410.87 L 261.61 203.50 Z" fill="#6fa6ff"
                  fill-rule="nonzero" node-id="102" stroke="none" target-height="410.87" target-width="462.39"
                  target-x="261.61" target-y="0" />
                <path d="M 400.04 419.57 L 366.70 266.63 L 724.00 0.00 L 402.95 288.41 L 400.04 419.57 Z"
                  fill="url(#未命名的渐变_27)" fill-rule="nonzero" node-id="104" stroke="none" target-height="419.56998"
                  target-width="357.3" target-x="366.7" target-y="0" />
                <path d="M 485.58 336.43 L 400.04 419.57 L 402.95 288.41 L 485.58 336.43 Z" fill="#005ae9"
                  fill-rule="nonzero" node-id="106" stroke="none" target-height="131.15997" target-width="85.53998"
                  target-x="400.04" target-y="288.41" />
              </svg>

              <span class=" one">工程类</span>
              <div class="two">一句话描述项目类型</div>
            </el-radio>
            <el-radio v-model="queryParams.radio1" label="3" border class="no-input">
              <svg height="24" node-id="1" sillyvg="true" template-height="1024" template-width="1024" version="1.1"
                viewBox="0 0 1024 1024" width="24" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs node-id="50">
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_15" node-id="5" spreadMethod="pad"
                    x1="253.01" x2="731.48" y1="804.43" y2="548.19">
                    <stop offset="0" stop-color="#ecf3ff" />
                    <stop offset="1" stop-color="#c9e2ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_5" node-id="8" spreadMethod="pad"
                    x1="106.43" x2="441.86" y1="753.29" y2="924.18">
                    <stop offset="0" stop-color="#c8e1ff" />
                    <stop offset="1" stop-color="#c5dfff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_12" node-id="11" spreadMethod="pad"
                    x1="476.95" x2="980.18" y1="845.48" y2="835.08">
                    <stop offset="0.06" stop-color="#c5dfff" />
                    <stop offset="0.23" stop-color="#8bb4f1" />
                    <stop offset="1" stop-color="#a2c5f7" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_29" node-id="15" spreadMethod="pad"
                    x1="548.65" x2="348.82" y1="245.15" y2="244.55">
                    <stop offset="0" stop-color="#63a0ff" />
                    <stop offset="0.49" stop-color="#77abff" />
                    <stop offset="1" stop-color="#63a0ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_142" node-id="19" spreadMethod="pad"
                    x1="231.65" x2="460.49" y1="495.59" y2="512.26">
                    <stop offset="0.17" stop-color="#509eff" />
                    <stop offset="1" stop-color="#0066ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_390" node-id="22" spreadMethod="pad"
                    x1="442.07" x2="442.58" y1="325.49" y2="229.77">
                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.6" />
                    <stop offset="0.94" stop-color="#ffffff" stop-opacity="0" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_377" node-id="25" spreadMethod="pad"
                    x1="718.2" x2="595.7" y1="460.99" y2="460.62">
                    <stop offset="0" stop-color="#0785ff" />
                    <stop offset="0.69" stop-color="#028bff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_142-2" node-id="28" spreadMethod="pad"
                    x1="523.64" x2="664.43" y1="618.26" y2="628.52">
                    <stop offset="0.17" stop-color="#509eff" />
                    <stop offset="1" stop-color="#0066ff" />
                  </linearGradient>
                  <linearGradient gradientUnits="objectBoundingBox" id="未命名的渐变_390-2" node-id="29" spreadMethod="pad"
                    x1="652.87" x2="653.18" y1="510.24" y2="451.56">
                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.6" />
                    <stop offset="0.94" stop-color="#ffffff" stop-opacity="0" />
                  </linearGradient>
                </defs>
                <path
                  d="M 417.27 437.00 C 456.95 413.51 524.32 412.89 567.74 435.59 L 921.34 620.46 C 964.76 643.17 967.83 680.61 928.15 704.10 L 605.43 895.10 C 565.75 918.60 498.43 919.22 454.96 896.51 L 101.36 711.69 C 57.94 688.99 54.87 651.54 94.55 628.05 Z"
                  fill="url(#未命名的渐变_15)" fill-rule="nonzero" node-id="111" stroke="none" target-height="506.32993"
                  target-width="912.96" target-x="54.87" target-y="412.89005" />
                <path
                  d="M 103.16 713.29 C 95.29 709.33 88.09 704.18 81.82 698.00 C 78.40 694.59 75.48 690.71 73.13 686.49 C 72.07 684.57 71.18 682.56 70.46 680.49 C 69.06 676.59 68.38 672.46 68.46 668.31 L 66.20 766.39 C 65.82 782.68 77.50 799.16 100.87 811.39 L 454.47 996.26 L 456.76 898.18 Z"
                  fill="url(#未命名的渐变_5)" fill-rule="nonzero" node-id="113" stroke="none" target-height="327.95"
                  target-width="390.93997" target-x="65.82" target-y="668.31" />
                <path
                  d="M 957.48 670.29 C 957.35 671.29 957.20 672.36 956.98 673.40 C 956.80 674.20 956.57 674.99 956.34 675.79 C 956.05 676.79 955.73 677.79 955.34 678.79 C 955.04 679.58 954.69 680.36 954.34 681.15 C 953.87 682.14 953.35 683.14 952.78 684.15 C 952.35 684.90 951.90 685.64 951.42 686.38 C 950.68 687.50 949.85 688.61 948.98 689.71 C 948.47 690.35 947.98 691.01 947.42 691.64 C 945.72 693.61 943.88 695.47 941.93 697.20 C 940.31 698.63 938.55 700.02 936.67 701.38 C 936.11 701.79 935.48 702.17 934.89 702.58 C 933.31 703.66 931.72 704.75 929.97 705.79 L 607.25 896.79 C 604.64 898.33 601.89 899.79 599.05 901.12 C 598.11 901.56 597.11 901.95 596.14 902.38 C 594.20 903.23 592.25 904.08 590.23 904.85 C 589.03 905.30 587.79 905.70 586.57 906.12 C 584.69 906.77 582.80 907.42 580.85 908.00 C 579.52 908.39 578.15 908.74 576.79 909.11 C 574.89 909.61 572.98 910.11 571.03 910.54 C 569.93 910.79 568.82 911.00 567.71 911.23 C 562.92 912.23 558.05 913.02 553.07 913.60 C 552.35 913.68 551.61 913.72 550.88 913.79 C 547.77 914.11 544.64 914.36 541.49 914.53 C 540.02 914.60 538.56 914.64 537.09 914.68 C 535.04 914.74 532.99 914.78 530.93 914.77 C 529.31 914.77 527.69 914.77 526.08 914.69 C 524.29 914.69 522.50 914.57 520.72 914.47 C 518.94 914.37 517.35 914.25 515.66 914.11 C 513.97 913.97 512.35 913.81 510.66 913.63 C 508.97 913.45 507.26 913.23 505.57 913.00 C 503.88 912.77 502.29 912.53 500.66 912.25 C 499.03 911.97 497.41 911.68 495.80 911.37 C 494.19 911.06 492.30 910.66 490.58 910.27 C 489.08 909.93 487.58 909.56 486.12 909.18 C 484.12 908.67 482.12 908.11 480.12 907.52 C 478.83 907.13 477.55 906.74 476.29 906.32 C 472.54 905.09 468.85 903.76 465.29 902.26 L 465.12 902.19 C 462.22 900.95 459.41 899.62 456.68 898.19 L 454.39 996.27 C 457.11 997.70 459.94 999.03 462.84 1000.27 L 462.84 1000.27 L 462.98 1000.27 C 466.51 1001.78 470.20 1003.11 473.98 1004.34 C 474.43 1004.49 474.84 1004.69 475.30 1004.83 C 476.12 1005.09 476.98 1005.28 477.82 1005.53 C 479.82 1006.12 481.77 1006.68 483.82 1007.20 C 484.54 1007.39 485.23 1007.62 485.95 1007.80 C 486.67 1007.98 487.51 1008.11 488.28 1008.29 C 490.01 1008.68 491.75 1009.04 493.50 1009.39 C 494.36 1009.55 495.19 1009.77 496.05 1009.92 C 496.91 1010.07 497.59 1010.15 498.36 1010.27 C 499.99 1010.54 501.63 1010.79 503.27 1011.01 C 504.18 1011.14 505.06 1011.31 505.97 1011.42 C 506.88 1011.53 507.57 1011.56 508.37 1011.65 C 510.02 1011.83 511.67 1011.99 513.37 1012.13 C 514.26 1012.20 515.15 1012.32 516.05 1012.38 C 516.95 1012.44 517.63 1012.44 518.42 1012.48 C 520.21 1012.58 521.99 1012.66 523.78 1012.71 C 524.69 1012.71 525.60 1012.81 526.51 1012.82 C 527.22 1012.82 527.92 1012.82 528.63 1012.82 C 530.69 1012.82 532.74 1012.82 534.79 1012.73 C 535.79 1012.73 536.79 1012.73 537.70 1012.73 C 538.20 1012.73 538.70 1012.64 539.19 1012.61 C 542.34 1012.45 545.47 1012.20 548.58 1011.88 C 549.21 1011.82 549.84 1011.80 550.46 1011.73 L 550.78 1011.68 C 555.78 1011.11 560.62 1010.29 565.41 1009.32 C 565.94 1009.21 566.49 1009.17 567.02 1009.06 C 567.55 1008.95 568.15 1008.76 568.73 1008.63 C 570.68 1008.19 572.59 1007.70 574.49 1007.19 C 575.85 1006.83 577.22 1006.48 578.56 1006.08 C 580.50 1005.50 582.39 1004.86 584.28 1004.21 C 585.50 1003.79 586.74 1003.39 587.93 1002.94 C 589.93 1002.17 591.93 1001.32 593.85 1000.46 C 594.85 1000.04 595.85 999.65 596.76 999.20 C 599.60 997.86 602.34 996.42 604.95 994.88 L 927.66 803.80 L 929.18 802.88 C 930.38 802.13 931.47 801.35 932.59 800.58 C 933.17 800.18 933.81 799.79 934.37 799.39 C 936.22 798.04 937.97 796.66 939.58 795.25 L 939.58 795.25 C 941.53 793.52 943.36 791.67 945.06 789.70 C 945.23 789.51 945.45 789.34 945.61 789.15 C 945.99 788.70 946.26 788.22 946.61 787.77 C 947.48 786.67 948.31 785.56 949.05 784.44 C 949.26 784.12 949.54 783.81 949.74 783.49 C 949.94 783.17 950.17 782.63 950.42 782.20 C 950.98 781.20 951.50 780.20 951.97 779.20 C 952.17 778.80 952.44 778.40 952.61 777.99 C 952.78 777.58 952.85 777.22 953.00 776.84 C 953.38 775.84 953.70 774.84 954.00 773.90 C 954.14 773.43 954.36 772.96 954.48 772.49 C 954.60 772.02 954.57 771.83 954.64 771.49 C 954.86 770.49 955.01 769.42 955.14 768.38 C 955.20 767.86 955.35 767.38 955.39 766.82 C 955.43 766.26 955.46 765.71 955.47 765.16 L 957.76 667.07 C 957.78 668.14 957.61 669.21 957.48 670.29 Z"
                  fill="url(#未命名的渐变_12)" fill-rule="nonzero" node-id="115" stroke="none" target-height="345.74994"
                  target-width="503.39" target-x="454.39" target-y="667.07" />
                <path
                  d="M 535.52 914.81 C 508.20 914.81 480.60 909.16 458.90 897.81 L 104.68 714.15 C 82.16 702.38 66.86 686.53 68.48 669.46 C 69.42 659.55 70.85 655.57 73.01 652.07 C 73.63 663.66 73.38 670.69 78.12 679.59 C 83.60 689.59 96.27 699.36 108.94 705.98 L 462.24 885.25 C 504.53 907.37 570.32 906.79 608.89 883.94 L 937.75 700.49 L 613.24 896.29 C 592.43 908.61 564.13 914.81 535.52 914.81 Z"
                  fill="#ffffff" fill-rule="nonzero" node-id="117" stroke="none" target-height="262.74"
                  target-width="870.8901" target-x="66.86" target-y="652.07" />
                <path d="M 653.14 241.31 L 444.06 167.08 L 231.89 241.93 L 444.10 322.60 L 653.14 241.31 Z"
                  fill="url(#未命名的渐变_29)" fill-rule="nonzero" node-id="119" stroke="none" target-height="155.52"
                  target-width="421.25" target-x="231.89" target-y="167.08" />
                <path d="M 444.10 764.75 L 231.89 667.03 L 231.89 241.93 L 444.10 322.60 L 444.10 764.75 Z"
                  fill="url(#未命名的渐变_142)" fill-rule="nonzero" node-id="121" stroke="none" target-height="522.82"
                  target-width="212.21" target-x="231.89" target-y="241.93" />
                <path d="M 444.10 764.75 L 653.14 666.42 L 653.14 241.31 L 444.10 322.60 L 444.10 764.75 Z"
                  fill="#005ae9" fill-rule="nonzero" node-id="123" stroke="none" target-height="523.44"
                  target-width="209.04001" target-x="444.1" target-y="241.31" />
                <path d="M 231.89 241.93 L 444.10 322.60 L 653.14 241.31 L 444.10 314.63 L 231.89 241.93 Z"
                  fill="url(#未命名的渐变_390)" fill-rule="nonzero" node-id="125" stroke="none" target-height="81.29001"
                  target-width="421.25" target-x="231.89" target-y="241.31" />
                <path d="M 782.26 458.63 L 654.09 413.13 L 524.02 459.01 L 654.11 508.46 L 782.26 458.63 Z"
                  fill="url(#未命名的渐变_377)" fill-rule="nonzero" node-id="127" stroke="none" target-height="95.32999"
                  target-width="258.23993" target-x="524.02" target-y="413.13" />
                <path d="M 654.11 787.05 L 524.02 727.14 L 524.02 459.01 L 654.11 508.46 L 654.11 787.05 Z"
                  fill="url(#未命名的渐变_142-2)" fill-rule="nonzero" node-id="129" stroke="none" target-height="328.03998"
                  target-width="130.08997" target-x="524.02" target-y="459.01" />
                <path d="M 654.11 787.05 L 782.26 726.76 L 782.26 458.63 L 654.11 508.46 L 654.11 787.05 Z"
                  fill="#005ae9" fill-rule="nonzero" node-id="131" stroke="none" target-height="328.41995"
                  target-width="128.14996" target-x="654.11" target-y="458.63004" />
                <path d="M 524.02 459.01 L 654.11 508.46 L 782.26 458.63 L 653.14 500.59 L 524.02 459.01 Z"
                  fill="url(#未命名的渐变_390-2)" fill-rule="nonzero" node-id="133" stroke="none" target-height="49.829956"
                  target-width="258.23993" target-x="524.02" target-y="458.63004" />
                <path d="M 350.74 721.81 L 307.31 701.81 L 307.31 614.80 L 350.74 631.31 L 350.74 721.81 Z"
                  fill="#ffffff" fill-rule="nonzero" node-id="135" stroke="none" target-height="107.01001"
                  target-width="43.429993" target-x="307.31" target-y="614.8" />
                <g node-id="166">
                  <path d="M 420.19 399.17 L 255.80 326.94 L 255.80 302.81 L 420.19 371.55 L 420.19 399.17 Z"
                    fill="#ffffff" fill-opacity="0.3" fill-rule="nonzero" group-id="1" node-id="139" stroke="none"
                    target-height="96.360016" target-width="164.38998" target-x="255.80002" target-y="302.81" />
                </g>
                <g node-id="167">
                  <path d="M 420.19 460.70 L 255.80 388.48 L 255.80 364.35 L 420.19 433.08 L 420.19 460.70 Z"
                    fill="#ffffff" fill-opacity="0.3" fill-rule="nonzero" group-id="2" node-id="144" stroke="none"
                    target-height="96.350006" target-width="164.38998" target-x="255.80002" target-y="364.35" />
                </g>
                <g node-id="168">
                  <path d="M 420.19 522.24 L 255.80 450.01 L 255.80 425.88 L 420.19 494.62 L 420.19 522.24 Z"
                    fill="#ffffff" fill-opacity="0.3" fill-rule="nonzero" group-id="3" node-id="149" stroke="none"
                    target-height="96.359985" target-width="164.38998" target-x="255.80002" target-y="425.88" />
                </g>
                <g node-id="169">
                  <path d="M 673.54 745.60 L 689.71 737.97 L 689.33 522.10 L 673.54 528.57 L 673.54 745.60 Z"
                    fill="#ffffff" fill-opacity="0.2" fill-rule="nonzero" group-id="4" node-id="154" stroke="none"
                    target-height="223.5" target-width="16.170044" target-x="673.54" target-y="522.1" />
                </g>
                <g node-id="170">
                  <path d="M 710.38 729.79 L 726.55 722.17 L 726.18 506.30 L 710.38 512.77 L 710.38 729.79 Z"
                    fill="#ffffff" fill-opacity="0.2" fill-rule="nonzero" group-id="5" node-id="159" stroke="none"
                    target-height="223.48996" target-width="16.169922" target-x="710.38" target-y="506.30002" />
                </g>
                <path d="M 747.23 715.06 L 763.40 707.43 L 763.03 491.56 L 747.23 498.03 L 747.23 715.06 Z"
                  fill="#ffffff" fill-opacity="0.2" fill-rule="nonzero" group-id="6" node-id="164" stroke="none"
                  target-height="223.49997" target-width="16.170044" target-x="747.23" target-y="491.56003" />
              </svg>


              <span class=" one">货物类</span>
              <div class="two">一句话描述项目类型</div>
            </el-radio>
          </el-form-item>
          <el-form-item label="投标文件名称" prop="bidName">
            <div class="flex-row " style=" width: 400px;">

              <el-input v-model="queryParams.bidName" placeholder="请填写投标文件名称 或 使用智能填充" clearable
                @keyup.enter.native="handleQuery" />
              <el-button
                style=" background:  linear-gradient( 136deg, #2AB9FC 0%, #595FF3 100%); margin-left: 20px; color: white;font-size: 14px;">智能填充</el-button>
            </div>


          </el-form-item>
          <el-form-item label="知识库" prop="planPageSize">
            <span class="fivv">撰写标书，自动匹配相关资料内容，内容更有针对性</span>
            <span class="forr">去创建知识库 ></span>

            <div class="sixx ffxf">


            </div>
          </el-form-item>
          <el-form-item label="企业资信" prop="planFontLength">
            <span class="fivv">撰写标书，自动匹配相关资料内容，内容更有针对性</span>
            <span class="forr">去创建资信库 ></span>
            <div class="sixx zzxf">


            </div>
          </el-form-item>


        </el-form>


      </div>

      <div v-show="stepactive == 3">

        <el-row :gutter="20" class="elrow">
          <el-col :span="12">
            <el-card id="myCard4" ref="myCard4" class="box-card">

              <div slot="header" class="clearfix">

                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="招标文件" name="first">


                  </el-tab-pane>
                  <el-tab-pane label="招标要求解读" name="second"></el-tab-pane>
                  <el-tab-pane label="评分标准解读" name="third"></el-tab-pane>
                  <el-tab-pane label="标书目录解读" name="fourth"></el-tab-pane>
                  <el-tab-pane disabled>

                    <template #label>
                      <!-- <span> -->
                      <svg t="1757669489386" @click="toggleFullScreen('myCard4')"
                        style="/*float: right; */padding: 3px 0;width: 18px; height: 18px;" class="icon"
                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200"
                        height="200">
                        <path
                          d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                          fill="#333333" p-id="2421"></path>
                      </svg>

                      <!-- </span> -->
                    </template>
                  </el-tab-pane>
                </el-tabs>


              </div>

              <div>
                <span style=" font-weight: 650; width: 65px;">项目背景</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                <span style=" font-weight: 650; width: 65px;font-size: 16px">招标内容</span>
                <br />

                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">1.核心引擎：</span>提供基于视觉大模型（ViT、SAM等相关技术）构建的新一代OCR识别引擎。<br />
                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">2.系统功能：</span>具备强大的文档分析与识别能力，包括复杂版面分析、表格识别、手写体识别、多语言混合识别、印章遮挡处理等。
                <br /><span
                  style="font-weight: 650; width: 65px;font-size: 14px">3.API接口：</span>提供稳定、高效、安全的API接口，支持与我单位现有业务系统进行集成。
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）

              </div>


            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card ref="myCard5" class="box-card">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;
                  </div>
                  <span style="padding-left: 6px; position: absolute;font-weight: 650;">技术/服务方案大纲</span>
                  <span
                    style="padding-left: 190px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span>
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard5')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- <div v-for="o in 4" :key="o" class="text item">
    {{'列表内容 ' + o }}
  </div> -->

              <div>
                <span style=" font-weight: 650; width: 65px;">项目背景</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                <span style=" font-weight: 650; width: 65px;font-size: 16px">招标内容</span>
                <br />

                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">1.核心引擎：</span>提供基于视觉大模型（ViT、SAM等相关技术）构建的新一代OCR识别引擎。<br />
                <span
                  style="font-weight: 650; width: 65px;font-size: 14px">2.系统功能：</span>具备强大的文档分析与识别能力，包括复杂版面分析、表格识别、手写体识别、多语言混合识别、印章遮挡处理等。
                <br /><span
                  style="font-weight: 650; width: 65px;font-size: 14px">3.API接口：</span>提供稳定、高效、安全的API接口，支持与我单位现有业务系统进行集成。
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）
                <br /><span style="font-weight: 650; width: 65px;font-size: 14px">4.定制化开发：</span>能根据我单位特定业务场景（如票据等）

              </div>

            </el-card>
          </el-col>

        </el-row>


        <div class="osteps">

          <el-card ref="myCard6" class="box-card">
            <div slot="header" class="clearfix">
              <div class="flex-row justify-between">
                <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                  &nbsp;&nbsp;
                </div>
                <span style="padding-left: 6px; position: absolute;font-weight: 650;">标书篇幅选择</span>
                <span
                  style="padding-left: 190px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">选择页数或字数</span>
                <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                <svg t="1757669489386" @click="toggleFullScreen('myCard6')"
                  style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                  version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                  <path
                    d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                    fill="#333333" p-id="2421"></path>
                </svg>
              </div>
            </div>
            <el-slider v-model="value2" :format-tooltip="formatTooltip" :marks="marks" show-stops>
            </el-slider>
            <br />
            <br />
            <el-radio v-model="radio" label="1">
              按页数:
              <el-input v-model="input" placeholder="请输入"></el-input>
              页，约 0 字


            </el-radio>

            <br />
            <br />
            <el-radio v-model="radio" label="2">
              按字数:
              <el-input v-model="input" placeholder="请输入"></el-input>
              字，约 0 页

            </el-radio>
            <div></div>

          </el-card>

        </div>





      </div>

      <div v-show="stepactive == 4">

        <el-row :gutter="20" class="elrow">
          <el-col :span="8">

            <!-- <el-card class="box-card" body-style="height: calc(100% - 50px)" style="overflow-y: auto;"> -->
            <el-card ref="myCard7" class="box-card">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;</div>
                  <span style="padding-left: 6px;  position: absolute;font-weight: 650;">招标要求</span>
                  <span
                    style="padding-left: 120px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span>
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard7')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- default-expand-all	 -->
              <el-tree :data="tree" highlight-current node-key="id" :props="{
                children: 'children',
                label: 'name'
              }" @node-expand="openTreeNode" @node-collapse="closeTreeNode" ref="tree" @node-contextmenu="openTreeMenu">
                <template #default="{ node, data }">
                  <span class="custom-node">
                    <!-- 一级节点图标 -->
                    <i v-if="node.level === 1" class="el-icon-folder-opened" v-html="'&nbsp;&nbsp;'"> </i>
                    <!-- 二级节点图标 -->
                    <i v-else-if="node.level === 2" class="el-icon-document" v-html="'&nbsp;&nbsp;'"></i>
                    <!-- 三级节点图标 -->
                    <i v-else-if="node.level === 3" class="el-icon-set-up" v-html="'&nbsp;&nbsp;'"></i>
                    <!-- 其他节点图标 -->
                    <i v-else class="el-icon-collection" v-html="'&nbsp;&nbsp;'"></i>
                    <span>{{ node.label }}</span>
                  </span>
                </template>
              </el-tree>


            </el-card>
          </el-col>
          <el-col :span="16">
            <el-card ref="myCard8" class="box-card">
              <div slot="header" class="clearfix">
                <div class="flex-row justify-between">
                  <div style="background-color: rgba(0, 96, 255, 1); border-radius: 38px;width: 4px;height: 20px;">
                    &nbsp;&nbsp;</div>
                  <span style="padding-left: 6px; position: absolute;font-weight: 650;">第一章. 技术方案整体评价</span>
                  <!-- <span style="padding-left: 120px;position: absolute;font-weight: 300;font-size: 14px;height: 30px;">解析完后可手动修改</span> -->
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                  <svg t="1757669489386" @click="toggleFullScreen('myCard8')"
                    style="float: right; padding: 3px 0;width: 20px; height: 20px;" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2420" width="200" height="200">
                    <path
                      d="M459.861 564.139a42.667 42.667 0 0 1 0 60.33L230.997 853.333H384a42.667 42.667 0 0 1 0 85.334H126.635l-2.304-0.171-1.28-0.128-1.579-0.213a42.795 42.795 0 0 1-0.981-0.171l-1.024-0.17a42.368 42.368 0 0 1-25.174-15.574l3.499 3.925a43.008 43.008 0 0 1-12.459-29.312V640a42.667 42.667 0 0 1 85.334 0v152.917L399.53 564.14a42.667 42.667 0 0 1 60.33 0zM896 85.333h0.853c0.896 0 1.835 0.086 2.731 0.171l-3.584-0.17a43.008 43.008 0 0 1 7.51 0.682l0.98 0.17a42.368 42.368 0 0 1 17.665 8.107l0.085 0.043 0.427 0.384a42.626 42.626 0 0 1 6.912 6.955l-3.414-3.84a43.008 43.008 0 0 1 12.459 28.8v-0.043l0.043 1.408v256a42.667 42.667 0 0 1-85.334 0V230.997L624.47 459.861a42.667 42.667 0 0 1-60.33-60.33l228.778-228.864H640a42.667 42.667 0 0 1 0-85.334h256z"
                      fill="#333333" p-id="2421"></path>
                  </svg>
                </div>
              </div>
              <!-- <div v-for="o in 4" :key="o" class="text item">
    {{'列表内容 ' + o }}
  </div> -->

              <div>
                <span style=" font-weight: 650; width: 65px;">（一）正文内容文案正文内容文案</span>
                <span
                  style="float: right; font-weight: 450; width: 65px; background: -webkit-linear-gradient(#3993ff, #f56991);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">解析中...</span>

              </div>
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率
              </div>
              <br />
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取。
              </div>
              <br />
              <div>
                响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程。
              </div>
              <br />
              <div>
                为响应国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，我单位拟引入先进的OCR（光学字符识别）技术，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率。
              </div>
              <br />
              <div>
                国家关于推动人工智能与实体经济深度融合的号召，顺应各行业智能化转型趋势，以解决传统OCR在复杂场景下识别精度低、适应性差、定制成本高等问题，全面提升我单位在文档数字化、信息提取与业务流程自动化方面的能力与效率。
                <br />
              </div>

            </el-card>
          </el-col>

        </el-row>
      </div>






      <!-- <div  class="flex-row justify-between" > -->
      <div style=" width: 20%; margin-left: auto; margin-right: auto; margin-top: 10px;" v-show="stepactive < 4">

        <el-button size="85 " @click="backactive">返&nbsp;&nbsp;回</el-button>
        <el-button size="85 " type="primary" @click="nextactive">下一步</el-button>

      </div>

      <div style=" width: 20%; margin-left: auto; margin-right: auto; margin-top: 10px;" v-show="stepactive == 4">

        <el-button size="85 " @click="backactive">上一步</el-button>
        <el-button size="85 " type="primary" @click="nextactive">保存</el-button>
        <el-button size="85 " type="primary" @click="nextactive">下载标书</el-button>

      </div>

      <!-- 
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['biddingdocument:bid:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['biddingdocument:bid:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['biddingdocument:bid:remove']"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['biddingdocument:bid:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row> -->

      <!-- <el-table v-loading="loading" :data="bidList" @selection-change="handleSelectionChange"  border max-height="650">
      <el-table-column type="selection" width="40" align="center" />
      <el-table-column label="主键" align="center" prop="pid" />
      <el-table-column label="租户" align="center" prop="tenantId" />
      <el-table-column label="标书编号" align="center" prop="bidNumber" />
      <el-table-column label="标书名称" align="center" prop="bidName" />
      <el-table-column label="标书类型" align="center" prop="bidType" />
      <el-table-column label="招标要求" align="center" prop="biddingRequirements" />
      <el-table-column label="评分标准" align="center" prop="gradingCriteria" />
      <el-table-column label="风险评估项" align="center" prop="riskAssessmentItems" />
      <el-table-column label="标书目录" align="center" prop="bidTableContents" />
      <el-table-column label="标书大纲" align="center" prop="bidOutline" />
      <el-table-column label="标书计划页数" align="center" prop="planPageSize" />
      <el-table-column label="标书计划字数" align="center" prop="planFontLength" />
      <el-table-column label="评分自测状态" align="center" prop="selfAssessmentStatus" />
      <el-table-column label="评分自测分数" align="center" prop="selfAssessmentScore" />
      <el-table-column label="风险评估状态" align="center" prop="riskAssessmentStatus" />
      <el-table-column label="风险评估项目数量" align="center" prop="riskAssessmentNumber" />
      <el-table-column label="版本号" align="center" prop="version" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['biddingdocument:bid:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['biddingdocument:bid:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table> -->

      <!-- <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    /> -->

      <!-- 添加或修改标书对话框 -->
      <!-- <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item>
        <el-form-item label="标书编号" prop="bidNumber">
          <el-input v-model="form.bidNumber" placeholder="请输入标书编号" />
        </el-form-item>
        <el-form-item label="标书名称" prop="bidName">
          <el-input v-model="form.bidName" placeholder="请输入标书名称" />
        </el-form-item>
        <el-form-item label="招标要求" prop="biddingRequirements">
          <el-input v-model="form.biddingRequirements" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="评分标准" prop="gradingCriteria">
          <el-input v-model="form.gradingCriteria" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="风险评估项" prop="riskAssessmentItems">
          <el-input v-model="form.riskAssessmentItems" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书目录" prop="bidTableContents">
          <el-input v-model="form.bidTableContents" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书大纲" prop="bidOutline">
          <el-input v-model="form.bidOutline" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书计划页数" prop="planPageSize">
          <el-input v-model="form.planPageSize" placeholder="请输入标书计划页数" />
        </el-form-item>
        <el-form-item label="标书计划字数" prop="planFontLength">
          <el-input v-model="form.planFontLength" placeholder="请输入标书计划字数" />
        </el-form-item>
        <el-form-item label="评分自测分数" prop="selfAssessmentScore">
          <el-input v-model="form.selfAssessmentScore" placeholder="请输入评分自测分数" />
        </el-form-item>
        <el-form-item label="风险评估项目数量" prop="riskAssessmentNumber">
          <el-input v-model="form.riskAssessmentNumber" placeholder="请输入风险评估项目数量" />
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本号" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { listBid, getBid, delBid, addBid, updateBid } from "@/api/biddingdocument/bid";

export default {
  name: "Bid",
  data() {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 标书表格数据
      bidList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        bidNumber: null,
        bidName: null,
        bidType: null,
        biddingRequirements: null,
        gradingCriteria: null,
        riskAssessmentItems: null,
        bidTableContents: null,
        bidOutline: null,
        planPageSize: null,
        planFontLength: null,
        selfAssessmentStatus: null,
        selfAssessmentScore: null,
        riskAssessmentStatus: null,
        riskAssessmentNumber: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },

      cardh: "",
      stepactive: 1,


      isFullScreen1: false, // 控制全屏状态的变量

      myCardwidth: '100vw',
      myCardheight: '100vh',
      myCardposition: 'fixed',
      myCardtop: '0',
      myCardleft: '0',
      myCardzIndex: '2000',


      value2: 0,
      marks: {
        0: '0',
        10: '100',
        20: '200',
        30: '300',
        40: '400',
        50: '500',
        60: '600',
        70: '700',
        80: '800',
        90: '900',
        100: '1000',
      },

      // three
      showTreeMenu: false,
      contextNode: {},
      tree: [
        {
          id: 1,
          name: '一级目录',
          children: [
            {
              id: 5,
              name: '二级目录',
              children: [
                {
                  id: 17,
                  name: '三级目录',
                  children: []
                },
                {
                  id: 18,
                  name: '三级目录',
                  children: []
                }
              ]
            },
            {
              id: 6,
              name: '二级目录',
              children: [
                {
                  id: 19,
                  name: '三级目录',
                  children: []
                },
                {
                  id: 20,
                  name: '三级目录',
                  children: []
                },
                {
                  id: 21,
                  name: '三级目录',
                  children: [
                    {
                      id: 22,
                      name: '四级目录',
                      children: []
                    },
                    {
                      id: 23,
                      name: '四级目录',
                      children: []
                    },
                    {
                      id: 24,
                      name: '四级目录',
                      children: []
                    },
                    {
                      id: 25,
                      name: '四级目录',
                      children: []
                    },
                    {
                      id: 26,
                      name: '四级目录',
                      children: []
                    }
                  ]
                }
              ]
            },
            {
              id: 7,
              name: '二级目录',
              children: []
            },
            {
              id: 8,
              name: '二级目录',
              children: []
            },
            {
              id: 10,
              name: '二级目录',
              children: []
            }
          ]
        },
        {
          id: 2,
          name: '一级目录',
          children: [
            {
              id: 11,
              name: '二级目录',
              children: []
            },
            {
              id: 12,
              name: '二级目录',
              children: []
            }
          ]
        },
        {
          id: 3,
          name: '一级目录',
          children: [
            {
              id: 13,
              name: '二级目录',
              children: []
            },
            {
              id: 14,
              name: '二级目录',
              children: []
            },
            {
              id: 15,
              name: '二级目录',
              children: []
            },
            {
              id: 16,
              name: '二级目录',
              children: []
            }
          ]
        }
      ]

      // end three
    };
  },
  created() {
    // this.getList();
  },
  mounted() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDimensions);
  },
  methods: {

    //#region 

    /** 查询标书列表 */
    getList() {
      this.loading = true;
      listBid(this.queryParams).then(response => {
        this.bidList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        bidNumber: null,
        bidName: null,
        bidType: null,
        biddingRequirements: null,
        gradingCriteria: null,
        riskAssessmentItems: null,
        bidTableContents: null,
        bidOutline: null,
        planPageSize: null,
        planFontLength: null,
        selfAssessmentStatus: null,
        selfAssessmentScore: null,
        riskAssessmentStatus: null,
        riskAssessmentNumber: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加标书";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getBid(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改标书";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateBid(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addBid(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除标书编号为"' + pids + '"的数据项？').then(function () {
        return delBid(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => { });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biddingdocument/bid/export', {
        ...this.queryParams
      }, `bid_${new Date().getTime()}.xlsx`)
    },

    //#endregion

    nextactive() {
      if (this.stepactive++ > 3) this.stepactive = 1;
    },
    backactive() {
      if (this.stepactive-- < 2) this.stepactive = 1;
    },

    // 浏览器高度

    updateDimensions() {
      this.cardh = window.innerHeight - 550;
      // this.windowWidth = window.innerWidth;
    },

    toggleFullScreen(myCard) {
      this.isFullScreen1 = !this.isFullScreen1; // 切换全屏状态
      // const el = this.$refs.myCard1;
      //  const width = el.offsetWidth;
      if (this.isFullScreen1) {
        this.myCardwidth = this.$refs[myCard].$el.style.width;
        this.$refs[myCard].$el.style.width = '100vw';

        this.myCardheight = this.$refs[myCard].$el.style.height;
        this.$refs[myCard].$el.style.height = '100vh';

        this.myCardposition = this.$refs[myCard].$el.style.position;
        this.$refs[myCard].$el.style.position = 'fixed';

        this.myCardtop = this.$refs[myCard].$el.style.top;
        this.$refs[myCard].$el.style.top = '0';

        this.myCardleft = this.$refs[myCard].$el.style.left;
        this.$refs[myCard].$el.style.left = '0';

        this.myCardzIndex = this.$refs[myCard].$el.style.zIndex;
        this.$refs[myCard].$el.style.zIndex = '2000';
      } else {
        // 恢复默认样式或其他自定义样式
        this.$refs[myCard].$el.style.width = this.myCardwidth; // 或者设置为之前的宽度等
        this.$refs[myCard].$el.style.height = this.myCardheight;
        this.$refs[myCard].$el.style.position = this.myCardposition;
        this.$refs[myCard].$el.style.top = this.myCardtop;
        this.$refs[myCard].$el.style.left = this.myCardleft;
        this.$refs[myCard].$el.style.zIndex = this.myCardzIndex;
      }
    },

    formatTooltip(val) {
      return val * 10;
    }


  }
};
</script>
<style src="../../index1/common.css" />

<style scoped lang="scss">
.app-container {
  padding: 20px;
  position: absolute;
  height: 100%;
  width: 100%;
  // background: red;
}

.osteps {
  background-color: white;
  border-radius: 12px;

  // padding: 15px;

}



/* 上传组件  */
.upload-demo {

  width: 100%;
  background-color: #ffffff;
  // margin-top: 15px;

  border-radius: 12px;

}

::v-deep .el-upload {

  // padding-top: 22px;

  margin-left: 22px;
  margin-bottom: 22px;
  width: calc(100% - 44px);
}

::v-deep .el-upload-dragger {
  width: 100%;
  background-color: #eef5ff;
  height: auto;
  /* 可根据需求调整高度 */
}

/* ::v-deep .el-icon-upload{
  background-image: url("../../../assets/images/15.jpg");
} */

::v-deep .el-upload-dragger .el-icon-upload {
  /* font-size: 112px; */
  color: #C0C4CC;
  /* margin: 40px 0 16px; */
  /* margin: unset; */
  line-height: 50px;
  width: 50px;
  height: 50px;


  font-size: 0px;

  margin: unset;
}

::v-deep .el-icon-upload:before {

  /* 使用其他字体图标编码 */
  content: "\e6d9";
  /* 修改图标颜色 */
  /* color: #ff6700;  */
  /* background-image: url("../../../assets/images/login-background.jpg"); */

  /* content: unset; */

  // background-image: url("../../../assets/images/15.jpg");
  background-image: url("../../../assets/images/upload.png");

  background-size: cover;
  height: 100%;
  width: 100%;
  display: block;

}


.elrow {

  margin-top: 22px;

}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}



// 第二步 中的样式

// radio样式

::v-deep .no-input .el-radio__input {
  display: none;
}

::v-deep .no-input.is-checked {
  background: #f5f7fa;
}

.no-input {
  .one {
    font-size: 14px;
    color: black;
    font-weight: 600;
    padding-left: 5px;
  }

  .two {
    margin-top: 5px;
    padding-left: 40px;
  }
}

.el-radio--small.is-bordered {
  height: unset;
  padding: 8px 15px 14px 10px;
}

::v-deep .el-input__inner {
  width: 400px;
  height: 40px;

}

.forr {
  margin-left: 25px;
  color: #4087ff;
  font-size: 15px;
  font-weight: 550;
}

.fivv {
  font-size: 15px;
  color: #727272;
}

.sixx {
  // border-radius: 5px;
  border-color: rgb(187, 187, 187);
  border-style: dashed;
  border-width: 1px;
  height: 80px;
  width: 250px;
  margin-top: 15px;
}

.ffxf {
  background-image: url("../../../assets/images/zhishiku.png");
  background-size: 100%;

}

.zzxf {
  background-image: url("../../../assets/images/qiyezixin.png");
  background-size: 100%;

}


::v-deep #myCard4 {
  .el-tabs__nav {
    width: 100%;

    >.el-tabs__item {
      font-size: 16px;
      line-height: 16px;
      font-weight: 600;
      height: 30px;
    }
  }

  .el-card__header {
    width: 100%;

    border-bottom: unset;
    margin: 14px 15px 0px;
    padding: unset;
  }

  .el-card__body {
    padding: 0px 20px 20px 20px;
    overflow-y: auto;
    // height: 447px;
  }

}

::v-deep #tab-4 {
  right: 22px;
  position: absolute;
}
</style>
